export const adminMenu = [
    {
        label: 'Dashboard',
        icon: 'pi pi-fw pi-home',
        items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' }]
    },
    {
        label: 'Inventory',
        icon: 'pi pi-fw pi-home',
        items: [
            { label: 'Product', icon: 'pi pi-fw pi-box', to: '/product' },
        ]
    },
    {
        label: 'Supplier',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Supplier', icon: 'pi pi-fw pi-table', to: '/supplier' },
        ]
    },
    {
        label: 'Requisition',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Requisition', icon: 'pi pi-fw pi-table', to: '/requisition' },
        ]
    },
    {
        label: 'Work Order',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Work Order', icon: 'pi pi-fw pi-table', to: '/workorder' },
        ]
    },
    {
        label: 'Chalan',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Chalan', icon: 'pi pi-fw pi-table', to: '/chalan' },
        ]
    },
    {
        label: 'Stock',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Stock', icon: 'pi pi-fw pi-table', to: '/stock' },
        ]
    },
    {
        label: 'Sale',
        icon: 'pi pi-fw pi-shopping-cart',
        items: [
            // { label: 'Sale Manually', icon: 'pi pi-fw pi-shopping-cart', to: '/sale_manually' },
            { label: 'Sale', icon: 'pi pi-fw pi-shopping-cart', to: '/sale' },
            { label: 'Invoices', icon: 'pi pi-fw pi-shopping-cart', to: '/sale_details' },
        ]
    },
    {
        label: 'Return',
        icon: 'pi pi-fw pi-arrow-right-arrow-left',
        items: [
            { label: 'Return To Supplier', icon: 'pi pi-fw pi-arrow-right-arrow-left', to: '/return_to_supplier' },
            { label: 'Return From Employee', icon: 'pi pi-fw pi-arrow-right-arrow-left', to: '/return_from_employee' },
        ]
    },
    { separator: true },
    {
        label: 'Others',
        icon: 'pi pi-fw pi-tablet',
        items: [
            { label: 'Others', icon: 'pi pi-fw pi-tablet', to: '/others' },
        ]
    },
    { separator: true },
    {
        label: 'Report',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Report', icon: 'pi pi-fw pi-briefcase', to: '/report' },
        ]
    },
    { separator: true },
    {
        label: 'Users',
        icon: 'pi pi-fw pi-tablet',
        items: [
            { label: 'Users', icon: 'pi pi-fw pi-tablet', to: '/users' },
        ]
    },
    { separator: true },
    {
        label: 'Settings',
        icon: 'pi pi-spin pi-cog',
        items: [
            { label: 'Change password', icon: 'pi pi-spin pi-cog', to: '/change_password' },
            { label: 'Logout', icon: 'pi pi-fw pi-sign-out', to: '/logout' },
        ]
    },
    { separator: true },
    
];

export const menu = [
    {
        label: 'Favorites',
        icon: 'pi pi-fw pi-home',
        items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' }]
    },
    {
        label: 'Inventory',
        icon: 'pi pi-fw pi-home',
        items: [
            { label: 'Product', icon: 'pi pi-fw pi-box', to: '/product' },
        ]
    },
    {
        label: 'Supplier',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Supplier', icon: 'pi pi-fw pi-table', to: '/supplier' },
        ]
    },
    {
        label: 'Requisition',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Requisition', icon: 'pi pi-fw pi-table', to: '/requisition' },
        ]
    },
    {
        label: 'Work Order',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Work Order', icon: 'pi pi-fw pi-table', to: '/workorder' },
        ]
    },
    {
        label: 'Chalan',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Chalan', icon: 'pi pi-fw pi-table', to: '/chalan' },
        ]
    },
    {
        label: 'Stock',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Stock', icon: 'pi pi-fw pi-table', to: '/stock' },
        ]
    },
    {
        label: 'Sale',
        icon: 'pi pi-fw pi-shopping-cart',
        items: [
            // { label: 'Sale Manually', icon: 'pi pi-fw pi-shopping-cart', to: '/sale_manually' },
            { label: 'Sale', icon: 'pi pi-fw pi-shopping-cart', to: '/sale' },
            { label: 'Invoices', icon: 'pi pi-fw pi-shopping-cart', to: '/sale_details' },
        ]
    },
    {
        label: 'Return',
        icon: 'pi pi-fw pi-arrow-right-arrow-left',
        items: [
            { label: 'Return To Supplier', icon: 'pi pi-fw pi-arrow-right-arrow-left', to: '/return_to_supplier' },
            { label: 'Return From Employee', icon: 'pi pi-fw pi-arrow-right-arrow-left', to: '/return_from_employee' },
        ]
    },
    { separator: true },
    {
        label: 'UI Kit',
        icon: 'pi pi-fw pi-id-card',
        items: [
            { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', to: '/formlayout' },
            { label: 'Input', icon: 'pi pi-fw pi-check-square', to: '/input' },
            { label: 'Float Label', icon: 'pi pi-fw pi-bookmark', to: '/floatlabel' },
            { label: 'Invalid State', icon: 'pi pi-fw pi-exclamation-circle', to: '/invalidstate' },
            { label: 'Button', icon: 'pi pi-fw pi-mobile', to: '/button', className: 'rotated-icon' },
            { label: 'Table', icon: 'pi pi-fw pi-table', to: '/table' },
            { label: 'List', icon: 'pi pi-fw pi-list', to: '/list' },
            { label: 'Tree', icon: 'pi pi-fw pi-share-alt', to: '/tree' },
            { label: 'Panel', icon: 'pi pi-fw pi-tablet', to: '/panel' },
            { label: 'Overlay', icon: 'pi pi-fw pi-clone', to: '/overlay' },
            { label: 'Media', icon: 'pi pi-fw pi-image', to: '/media' },
            { label: 'Menu', icon: 'pi pi-fw pi-bars', to: '/menu' },
            { label: 'Message', icon: 'pi pi-fw pi-comment', to: '/messages' },
            { label: 'File', icon: 'pi pi-fw pi-file', to: '/file' },
            { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', to: '/chart' },
            { label: 'Misc', icon: 'pi pi-fw pi-circle-off', to: '/misc' }
        ]
    },
    { separator: true },
    {
        label: 'PrimeBlocks',
        icon: 'pi pi-fw pi-prime',
        items: [
            { label: 'Free Blocks', icon: 'pi pi-fw pi-eye', to: '/blocks', badge: 'NEW', badgeStyle: { width: '40px' } },
            { label: 'All Blocks', icon: 'pi pi-fw pi-globe', url: 'https://www.primefaces.org/primeblocks-react', target: '_blank' }
        ]
    },
    { separator: true },
    {
        label: 'Utilities',
        icon: 'pi pi-fw pi-compass',
        items: [
            { label: 'Icons', icon: 'pi pi-fw pi-prime', to: '/icons' },
            { label: 'PrimeFlex', icon: 'pi pi-fw pi-desktop', url: 'https://www.primefaces.org/primeflex', target: '_blank' }
        ]
    },
    {
        label: 'Pages',
        icon: 'pi pi-fw pi-pencil',
        items: [
            { label: 'Crud', icon: 'pi pi-fw pi-pencil', to: '/crud' },
            { label: 'Calendar', icon: 'pi pi-fw pi-calendar-plus', to: '/calendar' },
            { label: 'Timeline', icon: 'pi pi-fw pi-calendar', to: '/timeline' },
            { label: 'Landing', icon: 'pi pi-fw pi-user-plus', url: 'assets/pages/landing.html', target: '_blank' },
            { label: 'Login', icon: 'pi pi-fw pi-sign-in', to: '/login' },
            { label: 'Invoice', icon: 'pi pi-fw pi-dollar', to: '/invoice' },
            { label: 'Invoice2', icon: 'pi pi-fw pi-dollar', to: '/invoice2' },
            { label: 'Help', icon: 'pi pi-fw pi-question-circle', to: '/help' },
            { label: 'Error', icon: 'pi pi-fw pi-times-circle', to: '/error' },
            { label: 'Not Found', icon: 'pi pi-fw pi-exclamation-circle', to: '/notfound' },
            { label: 'Access Denied', icon: 'pi pi-fw pi-lock', to: '/access' },
            { label: 'Empty', icon: 'pi pi-fw pi-circle-off', to: '/empty' }
        ]
    },
    { separator: true },
    {
        label: 'Hierarchy',
        icon: 'pi pi-fw pi-align-left',
        items: [
            {
                label: 'Submenu 1',
                icon: 'pi pi-fw pi-align-left',
                items: [
                    {
                        label: 'Submenu 1.1',
                        icon: 'pi pi-fw pi-align-left',
                        items: [
                            { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-align-left' },
                            { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-align-left' },
                            { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-align-left' }
                        ]
                    },
                    {
                        label: 'Submenu 1.2',
                        icon: 'pi pi-fw pi-align-left',
                        items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-align-left' }]
                    }
                ]
            },
            {
                label: 'Submenu 2',
                icon: 'pi pi-fw pi-align-left',
                items: [
                    {
                        label: 'Submenu 2.1',
                        icon: 'pi pi-fw pi-align-left',
                        items: [
                            { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-align-left' },
                            { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-align-left' }
                        ]
                    },
                    {
                        label: 'Submenu 2.2',
                        icon: 'pi pi-fw pi-align-left',
                        items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-align-left' }]
                    }
                ]
            }
        ]
    },
    { separator: true },
    {
        label: 'Start',
        icon: 'pi pi-fw pi-download',
        items: [
            { label: 'Buy Now', icon: 'pi pi-fw pi-shopping-cart', command: () => window.open('https://www.primefaces.org/store', '_blank') },
            { label: 'Documentation', icon: 'pi pi-fw pi-info-circle', to: '/documentation' }
        ]
    }
];

export const storeManagerMenu = [
    {
        label: 'Favorites',
        icon: 'pi pi-fw pi-home',
        items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' }]
    },
    {
        label: 'Requisition',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Requisition', icon: 'pi pi-fw pi-table', to: '/requisition' },
        ]
    },
    {
        label: 'Work Order',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Work Order', icon: 'pi pi-fw pi-table', to: '/workorder' },
        ]
    },
    {
        label: 'Chalan',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Chalan', icon: 'pi pi-fw pi-table', to: '/chalan' },
        ]
    },
    {
        label: 'Stock',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Stock', icon: 'pi pi-fw pi-table', to: '/stock' },
        ]
    },
    {
        label: 'Report',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Report', icon: 'pi pi-fw pi-briefcase', to: '/report' },
        ]
    },
    { separator: true },
    {
        label: 'Settings',
        icon: 'pi pi-spin pi-cog',
        items: [
            { label: 'Change password', icon: 'pi pi-spin pi-cog', to: '/change_password' },
            { label: 'Logout', icon: 'pi pi-fw pi-sign-out', to: '/logout' },
        ]
    },
    { separator: true },
];

export const salesManMenu = [
    { separator: true },
    {
        label: 'Sale',
        icon: 'pi pi-fw pi-shopping-cart',
        items: [
            { label: 'Sale', icon: 'pi pi-fw pi-shopping-cart', to: '/sale' },
        ]
    },
    { separator: true },
    {
        label: 'Settings',
        icon: 'pi pi-spin pi-cog',
        items: [
            { label: 'Change password', icon: 'pi pi-spin pi-cog', to: '/change_password' },
            { label: 'Logout', icon: 'pi pi-fw pi-sign-out', to: '/logout' },
        ]
    },
    { separator: true },
];

export const reportMenu = [
    { separator: true },
    {
        label: 'Report',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Report', icon: 'pi pi-fw pi-briefcase', to: '/report' },
        ]
    },
    { separator: true },
    {
        label: 'Settings',
        icon: 'pi pi-spin pi-cog',
        items: [
            { label: 'Change password', icon: 'pi pi-spin pi-cog', to: '/change_password' },
            { label: 'Logout', icon: 'pi pi-fw pi-sign-out', to: '/logout' },
        ]
    },
    { separator: true },
];